import { styled } from "@mui/material";

export const Section = styled('section')(({ theme }) => (props) => ({
    padding: '24px  96px  ',
    minHeight: '75vh',
    [theme.breakpoints.down('md')]: {
        padding: '24px  48px  '
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px  24px  '
    },
    [theme.breakpoints.down('xs')]: {
        padding: '6px 12px  '
    }
}))
export const Content = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    margin: '24px 0',
    justifyContent: 'flex-start',
}))
export const Card = styled('div')(({ theme }) => (props) => ({
    maxWidth: '360px',
    width: '360px',
    maxHeight: '150px',
    // height: '150px',
    padding: '5px 0',
    margin: '0 10px',
    boxSizing: 'border-box',
    marginBottom: '16px',
    display: 'flex',
    justifyContent: 'space-evenly',
    [theme.breakpoints.down('md')]: {
        width: '322px'
    },
    [theme.breakpoints.down('sm')]: {
        marginBottom: '5px',
        padding: '0'
    }
}))

export const CardImag = styled('div')(({ theme }) => (props) => ({
    width: '144px',
    height: '144px',
    maxWidth: '144px',
    maxHeight: '144px',
    minWidth: '96px',
    minHeight: '96px',
    [theme.breakpoints.down('sm')]: {
        width: '96px',
        height: '96px'
    }
}))
export const Image = styled('img')(({ theme }) => (props) => ({
    width: '100%',
    height: '100%',
    borderRadius: theme.shape.borderRadius,

}))
export const CardText = styled('div')(({ theme }) => (props) => ({
    flex: '1',
    padding: '0 16px',
    [theme.breakpoints.down('sm')]: {
        padding: '0 8px'
    }
}))
export const Heading = styled('h5')(({ theme }) => (props) => ({
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '24px',
    letterSpacing: '0em',
    margin: '0',
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    [theme.breakpoints.down('sm')]: {
        fontSize: '18px',
    },
    [theme.breakpoints.down('xs')]: {
        fontSize: '14px',
    }
}))


export const TitleRaeteng = styled('p')(({ theme }) => (props) => ({
    fontSize: '12px',
    fontWeight: '300',
    lineHeight: '1.5vw',
    letterSpacing: '0em',
    display: 'block',
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.2vw'
    },
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.3vw'

    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '10px',
    }
}))

export const TextDiscretion = styled('p')(({ theme }) => (props) => ({
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '1.6vw',
    letterSpacing: '0em',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.2vw'
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '1.3vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
        fontWeight: '600',
        gap: '8px'
    },
    color: theme.palette.mode === 'light' ? theme.palette.text.light : theme.palette.text.dark

}))

export const TextResult = styled('h5')(({ theme }) => (props) => ({
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '29px',
    letterSpacing: '0em',
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    margin: '0 16px',
    [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
        margin: '0 8px',

    }

}))
export const TextSearched = styled('span')(({ theme }) => (props) => ({
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '29px',
    letterSpacing: '0em',
    color: theme.palette.mode === 'light' ? theme.palette.text.light : theme.palette.text.dark,
    [theme.breakpoints.down('sm')]: {
        fontSize: '14px'
    }
}))
export const ContentNotFound = styled('div')(({ theme }) => (props) => ({
    width: '100%',
    height: '50vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '10px'
}))
export const ImageNotFound = styled('img')(({ theme }) => (props) => ({
    width: '15vw',
    [theme.breakpoints.down('lg')]: {
        width: '18vw',
    },
    [theme.breakpoints.down('sm')]: {
        width: '180px',
        height: '180px'
    }
}))



// ===================================1